import { Injectable } from '@angular/core';
import { RecipeService } from '../../recipes/services/recipe.service';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { PATHS } from '@shared/constants/paths';
import { RecipeDetailService } from './recipe-detail.service';
import { concatMap, take, timer } from 'rxjs';
import { recipeDetailViewModel } from '@app/mpp/model/recipe-detail-view-model';
import { ProductService } from '@shared/services/product/product.service';
import { IngredientList, ItemType } from '@usf/mpp-types';

@Injectable({
  providedIn: 'root',
})
export class RecipeDetailResolverService {
  constructor(
    private router: Router,
    private recipeDetailService: RecipeDetailService,
    private productService: ProductService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): any {
    const recipeID = route.params['recipeId'];

    if (recipeID === undefined) {
      this.router.navigate([PATHS.MPP]);
      return;
    }
    this.recipeDetailService.updateSelectedRecipe(recipeID);

    // reads in viewModel and if unddefined sends the user back
    this.recipeDetailService.recipeViewModel
      .pipe(take(1))
      .subscribe((recipe: recipeDetailViewModel) => {
        if (recipe === undefined) {
          this.router.navigate([PATHS.MPP]);
        } else {
          const products = (recipe.ingredientList ?? [])
            .filter((ingredient: IngredientList) => {
              return ingredient.type === ItemType.USFPRODUCT;
            })
            .map((ingredient: IngredientList) => Number(ingredient.itemNumber));
          this.productService.loadProducts(products);
        }
      });
  }
}
